import React, { useEffect } from 'react';
import { navigate } from 'gatsby';
import Loader from '~/components/Loader';
import Default from '~/templates/Default';

const Redirect = (url) => {
    useEffect(() => {
        navigate(url);
    }, [url]);

    return (
        <Default>
            <Loader />
        </Default>
    );
};

export default Redirect;
